import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantDocuments } from '../mutations/deleteParticipantDocuments.mutation';
import type {
  DeleteParticipantDocumentsMutation,
  DeleteParticipantDocumentsMutationVariables,
} from '../types';

export const useDeleteParticipantDocumentsMutation = (
  options?: MutationOptions<
    DeleteParticipantDocumentsMutation,
    DeleteParticipantDocumentsMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantDocuments), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
